<template>
    <v-card class="pa-3 trainer-list-card skin-window--trainerdetail">

        <v-card-text v-if="trainer" class="pa-1 ma-0 trainer-list-outer">
            <v-card-text class="pa-2 ma-0 pt-0 pb-2 trainer-list-scroll-body" @click="openSkillInfo = null">
                <table class="trainer-info-table ma-0 pa-0">
                    <tbody class="trainer-list-adaptive-text" style="font-size: medium">
                    <tr>
                        <td>{{ $t('trainer.trainerList.level') }}</td>
                        <td>{{trainer.experience.level}}</td>
                    </tr>
                    <tr v-if="trainer.npc === false">
                        <td>{{ $t('trainer.trainerList.day') }}</td>
                        <td>{{trainer.position.days}}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('trainer.trainerList.position') }}</td>
                        <td>{{trainer.position && trainer.position.city ? $t('common.cityNames.' + trainer.position.city.name) : $t('trainer.trainerList.choosingPokemon')}}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('trainer.trainerList.nextMilestone') }}</td>
                        <td>{{trainer.position.nextCity ? $t('common.cityNames.' + trainer.position.nextCity.name) : $t('trainer.trainerList.lostCity')}}</td>
                    </tr>
                    </tbody>
                </table>

                <div class="trainer-main-row">
                    <div class="trainer-top-row">
                        <div class="trainer-portrait-wrap">
                            <v-img
                                v-if="trainer.img"
                                class="trainer-portrait-img"
                                :src="require(`@/assets/pic/trainer/${trainer.img}`)"
                                contain
                            />

                            <div v-if="trainer.badges && trainer.badges.length" class="trainer-badge-col">
                                <v-img
                                    v-for="badge in trainer.badges"
                                    :key="badge.id"
                                    :src="require(`@/assets/pic/badge/${badge.id}.png`)"
                                    class="trainer-badge-icon"
                                    contain
                                />
                            </div>
                        </div>

                        <div class="trainer-skill-col">
                            <div
                                v-for="(skill, index) in trainerSkills"
                                :key="skill.name"
                                class="trainer-skill-row"
                                :class="{'trainer-skill-row--active': openSkillInfo === skill.name}"
                                @click.stop="toggleSkillInfo(skill.name)"
                            >
                                <v-icon class="trainer-list-adaptive-text trainer-skill-icon">{{ skill.icon }}</v-icon>
                                <span class="trainer-list-adaptive-text trainer-skill-value">{{ trainer.trainerSkills[index] }}</span>

                                <OakSkillHintPopup
                                    v-if="openSkillInfo === skill.name"
                                    :skill="{icon: skill.icon, name: $t('trainer.trainerSkills.' + index + '.name'), description: $t('trainer.trainerSkills.' + index + '.description')}"
                                    @close="openSkillInfo = null"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <v-row dense class="ml-0 mr-0" v-if="trainer && trainer.pokemons">
                    <v-col class="col-4 col-sm-2 col-md-2"
                        v-for="(pokemon,index) in trainer.pokemons"
                        :key="index+'_poki'"
                    >
                        <PokemonTypeMinicard
                            :pokemon-type="pokemon.pokemonType"
                            :key="index+'_pok'"
                        />
                    </v-col>
                </v-row>

                <!-- rezerva pro plovouci zaviraci krizek ResponsiveDialogu - blokovy prvek za poslednim radkem, ne padding na kartu vyse -->
                <div class="trainer-list-close-spacer"></div>
            </v-card-text>
        </v-card-text>
    </v-card>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import PokemonTypeMinicard from "@/components/pokemon/PokemonTypeMinicard";
    import OakSkillHintPopup from "@/components/utils/OakSkillHintPopup";
    import {TRAINER_SKILLS} from "@/utils/trainerSkillsEnum";

    export default {
        components: {PokemonTypeMinicard, OakSkillHintPopup},
        props: {
            trainer: {type: Object, default: undefined},
        },
        data() {
            return {
                badges: [],
                pokemons: [],
                openSkillInfo: null,
                trainerSkills: JSON.parse(JSON.stringify(TRAINER_SKILLS)),
            }
        },
        computed: {
            ...mapGetters({
            }),
        },
        watch: {
            trainer() {
                this.loadData();
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            ...mapActions({
            }),
            loadData(){
                this.badges = this.trainer.badges.map(x => x.id);
                if (this.trainer.pokemons instanceof Object){
                    this.pokemons = Object.values(this.trainer.pokemons);
                } else {
                    this.pokemons = this.trainer.pokemons.map(x => x);
                }
            },
            toggleSkillInfo(name){
                this.openSkillInfo = this.openSkillInfo === name ? null : name;
            },
        },
    }
</script>

<style scoped>
    .theme--light .trainer-list-adaptive-text {
        color: rgba(0, 0, 0, .87);
    }
    .theme--dark .trainer-list-adaptive-text {
        color: rgba(255, 255, 255, .87);
    }
    /* flex:1 1 auto/min-height:0 retezec musi jit od korenove karty dolu, aby zaviraci krizek zustal prilepeny v rohu behem scrollovani vnitrniho obsahu - viz claude/components/trainer.md */
    .trainer-list-card {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        /* inherit misto Vuetify default 4px - jinak svar proti obalujici .responsive-dialog-card se skin radiusem */
        border-radius: inherit;
    }
    .trainer-list-outer {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }
    .trainer-list-scroll-body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }
    /* stejna hodnota jako CityTravelDialog.vue/CityHealDialog.vue/OfficerJennyDialog.vue, odpovida skutecne velikosti krizku */
    .trainer-list-close-spacer {
        height: var(--responsive-dialog-close-clearance);
    }
    .trainer-info-table {
        margin: 0 auto 4px !important;
    }

    .trainer-main-row {
        container-type: inline-size;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        width: 100%;
    }

    .trainer-top-row {
        display: flex;
        align-items: stretch;
        justify-content: center;
        gap: 12px;
        width: 100%;
    }

    .trainer-portrait-wrap {
        position: relative;
        flex: 0 0 auto;
    }

    .trainer-portrait-img {
        width: clamp(140px, 60cqi, 260px);
        max-height: 42vh;
        height: auto;
        flex: 0 0 auto;
    }

    /* prekryva obrazek zleva o 50% vlastni sirky - left:0 + translateX(-50%) */
    .trainer-badge-col {
        position: absolute;
        top: 4px;
        left: 0;
        transform: translateX(-50%);
        z-index: 1;
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .trainer-badge-icon {
        width: clamp(22px, 11cqi, 40px);
        height: clamp(22px, 11cqi, 40px);
        flex: 0 0 auto;
        filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .5));
    }

    .trainer-skill-col {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 0 0 auto;
        justify-content: space-evenly;
    }

    .trainer-skill-row {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 8px;
        border-radius: 6px;
        cursor: pointer;
        background-color: rgba(0, 0, 0, .05);
        border: 1px solid rgba(0, 0, 0, .08);
        transition: background-color .15s ease;
    }

    .trainer-skill-row:hover,
    .trainer-skill-row--active {
        background-color: rgba(0, 0, 0, .15);
    }

    .trainer-skill-icon.v-icon {
        font-size: clamp(16px, 7cqi, 30px);
    }

    .trainer-skill-value {
        font-size: clamp(13px, 5.5cqi, 22px);
        font-weight: bold;
        min-width: 1.5em;
    }
</style>

